module.exports = __webpack_public_path__ + "img/Bukayo Saka.65869b2a.png";